import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const PlusIcon16 = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d="M8 10.6667V8M8 8V5.33333M8 8H10.6667M8 8H5.33333M8 14C6.4087 14 4.88258 13.3679 3.75736 12.2426C2.63214 11.1174 2 9.5913 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14Z"
    stroke={props.color ?? '#0058AD'}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default PlusIcon16;
